<template>
  <div
    :class="
      cn('select-none text-sm font-light text-black/75', props.class, {
        'pointer-events-none opacity-50': disabled,
      })
    "
  >
    <UiCheckbox
      v-model="hasAcceptedTerms"
      :classes="{
        root: 'mt-10 items-baseline',
        icon: 'size-3',
        control: { root: 'size-3.5 rounded' },
      }"
    >
      <template #label>
        <i18n-t keypath="checkbox_label" tag="span">
          <template #terms>
            <UiButton
              class="font-normal text-black/75 underline"
              variant="link"
              size="flat"
              :to="{ name: 'termsofuse' }"
              target="_blank"
            >
              {{ t("terms") }}
            </UiButton>
          </template>
        </i18n-t>
      </template>
    </UiCheckbox>

    <!-- Disclaimer -->
    <i18n-t class="mt-1 block" keypath="under_checkbox_label" tag="span">
      <template #click>
        <UiButton
          class="font-normal text-black/75 underline"
          size="flat"
          variant="link"
          @click="() => downloadAgreementMutation.mutateAsync()"
        >
          {{ t("click") }}
        </UiButton>
      </template>
    </i18n-t>
  </div>
</template>

<script setup lang="ts">
import { useMutation } from "@tanstack/vue-query"

const props = defineProps<{
  class?: ClassValue
  disabled?: boolean
}>()

const { t } = useI18n()

const hasAcceptedTerms = defineModel<boolean>({ required: true })

const downloadAgreementMutation = useMutation({
  mutationFn: () => {
    return DocumentsService.downloadAgreement("finq_compensation_agreement")
  },
  onSuccess: async (res) => {
    const urlBlob = URL.createObjectURL(res.data)
    await downloadItem(urlBlob, "הסכם תגמול פינק.pdf")
  },
})
</script>

<i18n lang="json">
{
  "he": {
    "checkbox_label": "הבנתי ואני מסכים להתקשרות בהסכם זה. הסכם זה הינו בנוסף ל{terms} של FINQ.",
    "under_checkbox_label": "בנוסף, אנחנו נשלח העתק של הסכם זה לתיבת המייל שלך. לשמירת/הדפסת ההסכם {click}.",
    "terms": "תנאי השימוש",
    "click": "לחץ כאן"
  },
  "en": {}
}
</i18n>
